/* eslint-disable radix */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Spinner } from 'reactstrap';
import Footer from '~/components/Footer';
import Menu from '~/components/Menu';
import api from '~/services/api';
import { addGroupID } from '~/store/modules/Grupos/actions';
import { Container } from '~/styles/pagesStyle';
import { handleDeleteGroup, handleUpdateGroup } from '../GruposServices';
import UpdateCard from './UpdateCard';

const initialForm = {
  situacaoCadastral: 0,
};

function GrupoUpdate() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [groupData, setGroupData] = useState({});
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(initialForm);
  const date = new Date().toISOString();
  const userLogged = sessionStorage.getItem('@auth/userName');

  useEffect(() => {
    setLoading(true);
    async function getData() {
      dispatch(addGroupID(id));
      await api
        .get(`Grupo/${id}`)
        .then((response) => {
          setGroupData(response.data);
          setLoading(false);
        })
        .catch(() => {
          toast.error('Erro ao buscar dados do grupo, recarregue a página');
        });
    }
    getData();
  }, [id]);

  async function handleUpdate() {
    if (form.situacaoCadastral === 0) {
      toast.error('Insira a situação cadastral');
      return;
    }
    if (!form.groupName) {
      toast.error('Nome do grupo é obrigatório');
      return;
    }
    const grupo = {
      id,
      idPessoaEmpresa: groupData.idPessoaEmpresa,
      idSituacaoCadastral:
        form.situacaoCadastral || groupData.idSituacaoCadastral,
      nome: form.groupName || groupData.nome,
      dataInclusao: date,
      usuario: userLogged,
      excluido: false,
      idsModulo: [],
    };
    setLoading(true);
    await handleUpdateGroup(grupo, setLoading);
    history.push('/group/list');
  }

  async function handleDelete() {
    await handleDeleteGroup(setLoading);
    history.push('/group/list');
  }

  return (
    <Container>
      <Footer />
      <Menu />
      {loading ? (
        <Spinner
          style={{ width: '3rem', height: '3rem', margin: '20% 45% 0 0' }}
        />
      ) : (
        <UpdateCard
          groupData={groupData}
          handleUpdate={handleUpdate}
          handleDelete={handleDelete}
          setForm={setForm}
          form={form}
          loading={loading}
        />
      )}
    </Container>
  );
}

export default GrupoUpdate;
